package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.frontend.lib.react.simplified.tags.input
import games.polyclub.frontend.lib.react.simplified.tags.span
import games.polyclub.frontend.lib.react.utils.classSet
import games.polyclub.frontend.lib.react.utils.classes
import games.polyclub.service.player.id.api.OnlineMojangPlayerId
import games.polyclub.service.player.id.api.PlayerId
import games.polyclub.tool.functional.Option
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import kotlinx.coroutines.Deferred
import kotlinx.coroutines.async
import react.PropsWithClassName
import react.dom.events.ChangeEventHandler
import react.dom.events.KeyboardEventHandler
import react.useCallback
import react.useEffect
import react.useState
import web.html.HTMLInputElement
import web.html.InputType
import kotlin.coroutines.cancellation.CancellationException

external interface MinecraftInputProps : PropsWithClassName {
    var placeholder: String?
    var readOnly: Boolean?
    var required: Boolean?
    var value: String?
    var onValidationChange: ((String, Boolean?, PlayerId?) -> Unit)?
    var onChange: ((String) -> Unit)?
    var hideValidPrepend: Boolean?
    var iconAtRight: Boolean?
}

val MinecraftInput = SFC<MinecraftInputProps> { props ->
    val (minecraftNick, setMinecraftNick) = useState("")
    val (minecraftId, setMinecraftId) = useState<Option<PlayerId>?>(null)
    val (minecraftIdLookup, setMinecraftIdLookup) = useState<Deferred<PlayerId?>?>(null)

    val minecraftNickValueChange = useCallback<(String) -> Unit>(minecraftNick, setMinecraftNick) { value ->
        if (value != minecraftNick) {
            setMinecraftNick(value)
        }
    }
    val minecraftNickKeyUp = useCallback<KeyboardEventHandler<HTMLInputElement>>(minecraftNickValueChange) { ev ->
        minecraftNickValueChange(ev.currentTarget.value.trim())
    }
    val minecraftNickOnChange = useCallback<ChangeEventHandler<HTMLInputElement>>(minecraftNickValueChange) { ev ->
        val value = ev.currentTarget.value.trim()
        props.onChange?.invoke(value)
        minecraftNickValueChange(value)
    }

    val isBlank = minecraftNick.isBlank()
    val isLoading = minecraftIdLookup?.isActive == true
    val isOriginal = minecraftId?.map { it as? OnlineMojangPlayerId }?.isPresent == true
    val isFailed = minecraftId != null && minecraftIdLookup?.isCancelled == true

    useEffect(props.value) {
        props.value?.let { nick ->
            if (nick != minecraftNick) {
                setMinecraftNick(nick)
            }
        }
    }

    useEffect(minecraftNick, setMinecraftId, setMinecraftIdLookup) {
        var mounted = true
        setMinecraftId(null)
        props.onValidationChange?.invoke(minecraftNick, false, minecraftId?.getOrNull())
        val defer = appScope.async {
            if (!minecraftNick.matches(Regex("""[a-zA-Z0-9_]{2,16}"""))) {
                null
            } else {
                StoreBff.playerIdByNick(minecraftNick)
            }.also { playerId ->
                props.onValidationChange?.invoke(minecraftNick, playerId is OnlineMojangPlayerId, playerId)
                setMinecraftId(Option.of(playerId))
            }
        }
        defer.invokeOnCompletion { err ->
            if (err != null && err !is CancellationException) {
                if (mounted) {
                    props.onValidationChange?.invoke(minecraftNick, false, null)
                    setMinecraftId(Option.empty())
                }
            }
        }
        setMinecraftIdLookup(defer)
        cleanup {
            mounted = false
            defer.cancel()
        }
    }

    div("input-group ${props.classes}") {
        if (props.iconAtRight != true) {
            div("input-group-prepend") {
                span("input-group-text") {
                    AvatarIcon {
                        this.isLoading = isLoading
                        this.isBlank = isBlank
                        this.minecraftId = minecraftId
                    }
                }
            }
        }
        input("form-control") {
            type = InputType.text
            placeholder = props.placeholder ?: ""
            onKeyUp = minecraftNickKeyUp
            onChange = minecraftNickOnChange
            value = props.value
            readOnly = props.readOnly
            required = props.required
            if (isLoading) {
                classSet += "is-validating"
            } else if (!isBlank) {
                minecraftId?.map { it as? OnlineMojangPlayerId }?.ifEmpty {
                    classSet += "is-invalid"
                }?.ifPresent {
                    classSet += "is-valid"
                }
            }
        }
        if (props.iconAtRight == true) {
            div("input-group-prepend") {
                span("input-group-text") {
                    AvatarIcon {
                        this.isLoading = isLoading
                        this.isBlank = isBlank
                        this.minecraftId = minecraftId
                    }
                }
            }
        } else if (!isBlank && !isLoading && (props.hideValidPrepend != true && (isFailed || !isOriginal))) {
            div("input-group-append") {
                span("input-group-text") {
                    if (isFailed) {
                        +"Ocorreu um erro ao validar :("
                    } else if (!isOriginal) {
                        +"Não Original"
                    } else {
                        +"Válido e Original"
                    }
                }
            }
        }
    }
}
